module.exports = __webpack_public_path__ + "static/240417_HSE_Change_in_management_Bond_signed-1ce5d31bb2ce305fc7df97f626acc657.pdf";